import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePrintFormatCreate,
  detail: routePrintFormatDetail,
  home: routePrintFormatsHome,
  root: routePrintFormatRoot,
} = createDoctypeRoutes({
  createName: 'new-print-format',
  createPath: 'new-print-format',
  detailName: 'print-format-detail',
  doctype: DOCTYPES.PRINT_FORMAT,
  homeName: 'print-formats-home',
  path: 'print-format',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/printFormats/AddPrintFormat.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/printFormats/ViewPrintFormat.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/printFormats/PrintFormatView.vue'),
  },
})

export {
  routePrintFormatCreate,
  routePrintFormatDetail,
  routePrintFormatRoot,
  routePrintFormatsHome,
}
